import {
  useSessionStore,
} from "~/stores/session";

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) {
    return;
  }

  const sessionStore = useSessionStore();
  const allowedRoles = ["TENANT_MANAGER", "TENANT_ADMIN", "AIL_ADMIN"];
  if (!allowedRoles.some((role) => sessionStore.userRoles.includes(role))) {
    return navigateTo("/home");
  }
});
